import { QueryModelCore } from "../core/model.core";
import { setLogin, clearLogin, getTokenWithoutBearer } from '../core/authUtil';

export default class Auth {
  /**
   * 登录
   * @param {string} username 用户名
   * @param {string} password 密码
   */
  async login({ username, password }) {
    const result = await new QueryModelCore('/proxyApi/login').post({ username, password });
    setLogin();
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 退出登录
   */
  async logout() {
    const token = getTokenWithoutBearer();
    clearLogin();
    await new QueryModelCore('/proxyApi/loginOut').post({ token });
    return null;
  }

  /**
   * 获取用户信息
   */
  async profile() {
    const token = getTokenWithoutBearer();
    const result = await new QueryModelCore('/proxyApi/getUserInfo').get({ token });
    const { dataMap } = result;
    return dataMap;
  }
}